import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useEffect } from "react";
const eventsData = [
  {
    title: "VR Tech Summit Lorem ipsum dolor sit amet ",
    date: "March 15, 2025",
    location: "Virtual Event",
  },
  {
    title: "Immersive Experience Workshop",
    date: "April 10, 2025",
    location: "London, UK",
  },
  {
    title: "Loopstudios Product Launch",
    date: "June 5, 2025",
    location: "San Francisco, CA",
  },
];
function Events() {
   useEffect(() => {
    window.scrollTo(0, 10);
  }, []);

  return (
    <div className="bg-gradient-custom min-vh-100">
      <Navbar />
      <div className="container py-5">
        <h2 className="font-josefin font-light text-4xl text-uppercase text-center mb-5">
          EVENTS
        </h2>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          {eventsData.map((event, index) => (
            <div key={index} className="col">
              <div className="card h-100 bg-light shadow-sm">
                <div className="card-body p-4">
                  <h3 className="font-josefin font-light text-xl text-uppercase mb-3">
                    {event.title}
                  </h3>
                  <p className="font-alata text-secondary mb-2 line-height-relaxed">
                    <strong>Date:</strong> {event.date}
                  </p>
                  <p className="font-alata text-secondary mb-0">
                    <strong>Location:</strong> {event.location}
                  </p>
                </div>
                <div className="card-footer bg-transparent border-0 p-4 pt-0">
                  <button className="btn btn-dark w-100 text-uppercase font-josefin">
                    Register
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Events;
